import Button, { ButtonProps } from "./Button";
import Icon from "../Icon";
import { useAppSelector } from "../../hooks";
import { selectButton } from "../../store/slices/buttons";
import { getClasses } from "../../utils";
import Commander from "../../commander";
import classes from "../../styles/Buttons.module.css";

const TurboButton: React.FC<ButtonProps> = (props) => {
  const { available, disabled, hidden, active } = useAppSelector((state) => {
    return {
      ...selectButton("turbo", state),
      active: state.details.turbo,
      layout: state.layout,
    };
  });

  const onClick = () => Commander.toggleTurboSpin(!active);
  const icon = active ? "LightningOff" : "Lightning";
  // const isAvailable = available;

  if (!available) {
    return (
      <div
        className={getClasses(classes, "empty turbo", props.className)}
      ></div>
    );
  }

  return (
    <Button
      name="turbo"
      className={getClasses(classes, props.className, "turbo")}
      onClick={onClick}
      disabled={disabled}
      available={available}
      hidden={hidden}
      soundEffect="button-click"
    >
      <Icon type={icon} />
    </Button>
  );
};

export default TurboButton;
